import React, { memo, lazy, Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Hero from './components/Hero';
import SEOHead from '../../components/base/SEOHead';
import ErrorBoundary from '../../components/base/ErrorBoundary';
import LoadingSpinner from '../../components/base/LoadingSpinner';

// Lazy load components that are below the fold
const Features = lazy(() => import('./components/Features'));
const ArbitrageAdvert = lazy(() => import('./components/ArbitrageAdvert'));
const Investment = lazy(() => import('./components/Investment'));
const AITrading = lazy(() => import('./components/AITrading'));
const P2P = lazy(() => import('./components/P2P'));
const CryptoPayment = lazy(() => import('./components/CryptoPayment'));
const Ecosystem = lazy(() => import('./components/Ecosystem'));
const PepVerse = lazy(() => import('./components/PepVerse'));
const Tokenomics = lazy(() => import('./components/Tokenomics'));
const Roadmap = lazy(() => import('./components/Roadmap'));
const CTA = lazy(() => import('./components/CTA'));

// Simple loading fallback
const SectionLoader = () => (
  <div className="w-full h-32 flex items-center justify-center">
    <div className="w-8 h-8 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

export default function HomePage() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "PepCoin - Advanced Cryptocurrency Trading Platform",
    "description": "PepCoin offers secure cryptocurrency trading, mining, staking, and DeFi services. Join 500K+ users in the future of digital finance with advanced AI trading tools.",
    "url": "https://pepcoin.com"
  };

  return (
    <>
      <SEOHead 
        title="PepCoin - Advanced Cryptocurrency Trading Platform | AI Trading & Mining"
        description="PepCoin offers secure cryptocurrency trading, mining, staking, and DeFi services. Join 500K+ users in the future of digital finance with advanced AI trading tools."
        keywords="cryptocurrency, trading, mining, staking, DeFi, blockchain, PepCoin, digital finance, AI trading, P2P trading"
        schemaData={schemaData}
      />
      <ErrorBoundary>
        <div className="min-h-screen bg-black text-white overflow-x-hidden">
          <Navbar />
          <ErrorBoundary>
            <Hero />
          </ErrorBoundary>
          
          <div className="px-2 sm:px-4 lg:px-0">
            <Suspense fallback={<SectionLoader />}>
              <ErrorBoundary><Features /></ErrorBoundary>
            </Suspense>
            
            <Suspense fallback={<SectionLoader />}>
              <ErrorBoundary><ArbitrageAdvert /></ErrorBoundary>
            </Suspense>
            
            <Suspense fallback={<SectionLoader />}>
              <ErrorBoundary><Investment /></ErrorBoundary>
            </Suspense>
            
            <Suspense fallback={<SectionLoader />}>
              <ErrorBoundary><AITrading /></ErrorBoundary>
            </Suspense>
            
            <Suspense fallback={<SectionLoader />}>
              <ErrorBoundary><P2P /></ErrorBoundary>
            </Suspense>
            
            <Suspense fallback={<SectionLoader />}>
              <ErrorBoundary><CryptoPayment /></ErrorBoundary>
            </Suspense>
            
            <Suspense fallback={<SectionLoader />}>
              <ErrorBoundary><Ecosystem /></ErrorBoundary>
            </Suspense>
            
            <Suspense fallback={<SectionLoader />}>
              <ErrorBoundary><PepVerse /></ErrorBoundary>
            </Suspense>
            
            <Suspense fallback={<SectionLoader />}>
              <ErrorBoundary><Tokenomics /></ErrorBoundary>
            </Suspense>
            
            <Suspense fallback={<SectionLoader />}>
              <ErrorBoundary><Roadmap /></ErrorBoundary>
            </Suspense>
            
            <Suspense fallback={<SectionLoader />}>
              <ErrorBoundary><CTA /></ErrorBoundary>
            </Suspense>
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
}

HomePage.displayName = 'HomePage';
